
import wx from 'weixin-js-sdk'
import axios from 'axios'
export default function V_SHARE () {
    var wxlink = window.location.href.split("#")[0],
        data = new FormData();
    data.append('url', wxlink);
    axios.post("https://www.eventnet.cn/wxAjax/fx/index.php", data).then(el => {
        let d = el.data;
        wx.config({
            appId: d.appId,
            timestamp: d.timestamp,
            nonceStr: d.nonceStr,
            signature: d.signature,
            jsApiList: [
                'checkJsApi',
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'scanQRCode'
            ]
        })
        wx.ready(function () {
            iniShare({
                title: '东风日产供应商年会服务平台\n東風日産サプライヤー大会サービスデスク',
                desc: '中国·广州\n中国・広州',
                link: 'https://www.eventnet.cn/nissan_meeting/',
                logo: 'https://oss.eventnet.cn/H5/Nissan_meeting/2023/share.jpg?v=1'
            })
        })
        wx.error(function (res) {
            console.log(res.errMsg)
        })
    }).catch(function (error) {
        console.log(error);
    });
}

function iniShare (data) {
    var shareData = {
        title: data.title,
        desc: data.desc,
        link: data.link,
        imgUrl: data.logo,
        trigger: function (res) { },
        success: function (res) { },
        cancel: function (res) { },
        fail: function (res) { }
    }

    //好友
    wx.onMenuShareAppMessage(shareData)
    //朋友圈
    shareData = {
        title: data.title,
        link: data.link,
        imgUrl: data.logo,
        trigger: function (res) { },
        success: function (res) { },
        cancel: function (res) { },
        fail: function (res) { }
    }
    wx.onMenuShareTimeline(shareData)
}









// WEBPACK FOOTER //
// ./src/tz.js